import React from 'react';
import Pill from 'components/Pill';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
export function AdminPill() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Pill, {
    icon: "eye-closed",
    iconColor: "disabled",
    children: t('state_only_admins')
  });
}
export function EveryonePill() {
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_jsx(Pill, {
    icon: "eye-open",
    iconColor: "positive",
    children: t('state_everyone')
  });
}